import React from 'react';
import {useLoaderData, Await} from '@remix-run/react';

//components
import {Skeleton} from 'components/Skeleton';
import Module from 'components/modules/Module';

//data
import {loader} from '~/routes/($lang)/pages/$pageHandle';

export default function Page() {
  const {modules} = useLoaderData<typeof loader>();

  return (
    <div className="page-sections pb-20">
      <React.Suspense fallback={<Skeleton className="h-32" />}>
        <Await
          errorElement="There was a problem loading related products"
          resolve={modules}
        >
          {(modules) => {
            return (
              modules &&
              modules.map((module) => {
                return <Module key={module._key} module={module} />;
              })
            );
          }}
        </Await>
      </React.Suspense>
    </div>
  );
}
